import React, { useState } from 'react';

import { PropTypes } from 'prop-types';
import MHDRequests from 'services/MHDRequests';
import { LoadingHU } from 'components/LoadingHU';
import './SearchSpace.css';
import { toast } from 'react-toastify';
import { ToastMessage } from 'components';
import { isEmpty } from 'lodash';
import { Warning } from '../Warning';
import { ResultsTable } from '../Results';

export function AdvancedSearch({ type }) {
  const [loading, setLoading] = useState(false);
  const [nameComplete, setNameComplete] = useState('');
  const [filterBirthDate, setFilterBirthDate] = useState('');
  const data = true;
  const [isListOpen, setIsListOpen] = useState(false);
  const [genderFilter, setGenderFilter] = useState('');
  const [results, setResults] = useState({});
  const [isOpen, setIsOpen] = useState(true);
  const [noSearch, setNoSearch] = useState(true);

  const formatDate = (date) => {
    // Remove caracteres não numéricos
    const numericDate = date.replace(/\D/g, '');

    // Aplica a máscara DD/MM/AAAA
    if (numericDate.length >= 2 && numericDate.length <= 4)
      return `${numericDate.slice(0, 2)}/${numericDate.slice(2)}`;
    if (numericDate.length >= 5 && numericDate.length <= 8) {
      return `${numericDate.slice(0, 2)}/${numericDate.slice(
        2,
        4,
      )}/${numericDate.slice(4, 8)}`;
    }

    return numericDate.slice(0, 10);
  };

  const handleDateChange = (e) => {
    const inputDate = e.target.value;
    const formattedDate = formatDate(inputDate);
    setFilterBirthDate(formattedDate);
  };

  function unTranslateGenderFilter(gender) {
    if (gender) {
      if (gender === 'Masculino') return 'male';
      return 'female';
    }
    return '';
  }

  async function handleAdvancedSearch(name, birthdate, gender) {
    setLoading(true);
    try {
      if (!name || birthdate?.length !== 10 || !gender) {
        toast.error(
          <ToastMessage type="error">
            Verifique o preenchimento do formulário
          </ToastMessage>,
        );
      } else {
        const resultsJson = await MHDRequests.advancedSearch(
          name,
          birthdate,
          gender,
        );
        if (typeof resultsJson === 'string') throw new Error(resultsJson);
        if (resultsJson.total > 0) setResults(resultsJson.entry);
        else setResults({});
      }
    } catch (err) {
      setResults({});
      toast.error(
        <ToastMessage type="error">
          {' '}
          Não foi possível buscar o paciente.{' '}
        </ToastMessage>,
      );
    } finally {
      setLoading(false);
      setNoSearch(false);
    }
  }
  return (
    <div className="advancedSearch">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleAdvancedSearch(
            nameComplete,
            filterBirthDate?.split('/')?.reverse()?.join('-'),
            unTranslateGenderFilter(genderFilter),
          );
        }}
      >
        <div className="flex">
          <p> Filtros </p>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="br-button circle small"
            type="button"
          >
            {isOpen ? (
              <i className="fas fa-angle-up" aria-hidden="true" />
            ) : (
              <i className="fas fa-angle-down" aria-hidden="true" />
            )}
          </button>
        </div>
        {isOpen && (
          <>
            <div className="search">
              <div className="row">
                <div className="col-sm-6 mb-1">
                  <div className="br-input">
                    <label htmlFor="input-success">
                      Nome do paciente{' '}
                      <b style={{ fontSize: '30px', color: 'red' }}>*</b>
                    </label>

                    <input
                      required
                      onChange={(e) => setNameComplete(e.target.value)}
                      id="input-default"
                      type="text"
                      placeholder="Digite o nome do paciente"
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-3 mb-5">
                  <div className="br-input">
                    <label htmlFor="input-date">
                      Data de nascimento
                      <b style={{ fontSize: '30px', color: 'red' }}>*</b>
                    </label>

                    <input
                      required
                      value={filterBirthDate}
                      onChange={handleDateChange}
                      id="input-date"
                      type="text"
                      maxLength="10"
                      placeholder="dd/mm/yyyy"
                    />
                  </div>
                </div>

                <div className="col-sm-3 mb-1">
                  <div className="br-select">
                    <div className="br-input">
                      <label htmlFor="select-simple">
                        Sexo{' '}
                        <b style={{ fontSize: '30px', color: 'red' }}> * </b>
                      </label>

                      <input
                        required
                        id="select-simple"
                        type="text"
                        value={genderFilter}
                        placeholder="Selecione o item"
                        onClick={() => setIsListOpen(!isListOpen)}
                      />
                      <button
                        onClick={() => setIsListOpen(!isListOpen)}
                        className="advancedSearch-circleButton br-button"
                        type="button"
                        aria-label="Exibir lista"
                      >
                        {!isListOpen ? (
                          <i className="fas fa-angle-down" aria-hidden="true" />
                        ) : (
                          <i className="fas fa-angle-up" aria-hidden="true" />
                        )}
                      </button>
                    </div>
                    {isListOpen ? (
                      <div className="br-list" style={{ display: 'block' }}>
                        <div className="br-item">
                          <div className="br-radio">
                            <input
                              onClick={(e) =>
                                setIsListOpen(!isListOpen) &
                                setGenderFilter(e.target.value)
                              }
                              id="rb0"
                              type="radio"
                              name="gender-options"
                              value="Masculino"
                            />
                            <label htmlFor="rb0">Masculino</label>
                          </div>
                        </div>
                        <div className="br-item">
                          <div className="br-radio">
                            <input
                              onClick={(e) =>
                                setIsListOpen(!isListOpen) &
                                setGenderFilter(e.target.value)
                              }
                              id="rb27"
                              type="radio"
                              name="gender-options"
                              value="Feminino"
                            />
                            <label htmlFor="rb27">Feminino</label>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="br-checkbox d-inline">
                    <input
                      id="busca-avançada"
                      name="busca-avançada"
                      onChange={() => type(data)}
                      defaultChecked
                      type="checkbox"
                      aria-label="opção 1"
                    />
                    <label htmlFor="busca-avançada">Busca Avançada</label>
                  </div>
                </div>
                <div className="col-auto">
                  <button
                    onClick={() => setNoSearch(true)}
                    className="br-button secondary mt-3 mt-sm-0 ml-sm-3"
                    type="reset"
                  >
                    Limpar
                  </button>
                  <button
                    className="br-button primary mt-3 mt-sm-0 ml-sm-3"
                    type="submit"
                  >
                    Filtrar
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        <LoadingHU state={loading} />
        {!isEmpty(results) ? (
          <ResultsTable results={results} />
        ) : (
          <>{isEmpty(results) && !noSearch && <Warning />}</>
        )}
      </form>
    </div>
  );
}
AdvancedSearch.propTypes = {
  type: PropTypes.bool.isRequired,
};
